module.exports = "/_next/static/files/ede45435ef2fe0dde4736cf348a1652f.svg";